import { Directive, ElementRef, inject, OnInit, output, Renderer2 } from '@angular/core';

@Directive({
  selector: '[libAccessibleClick]',
  standalone: true,
  host: {
    '(click)': 'handleClick($event)',
    '(keyup.enter)': 'handleEnter($event)',
    '(keyup.space)': 'handleSpace($event)',
  },
})
export class AccessibleClickDirective implements OnInit {
  readonly libAccessibleClick = output<Event>();

  readonly el = inject(ElementRef);
  readonly renderer = inject(Renderer2);

  ngOnInit(): void {
    this.renderer.setAttribute(this.el.nativeElement, 'tabindex', '0');
    this.renderer.setAttribute(this.el.nativeElement, 'role', 'button');
  }

  handleClick(event: Event | KeyboardEvent): void {
    this.libAccessibleClick.emit(event);
  }

  handleEnter(event: KeyboardEvent | Event): void {
    this.libAccessibleClick.emit(event);
  }

  handleSpace(event: KeyboardEvent | Event): void {
    this.libAccessibleClick.emit(event);
  }
}
